import { GetAllUserOfferRequestsForAdminState } from './getAllUserOfferRequestsForAdmin.types'

const initialState: GetAllUserOfferRequestsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
